export default __webpack_public_path__ + "static/media/cardstill.62a7a021.png";